import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import ListSearch from "../bucket/ListSearch";
import { CustomTooltip } from "../tooltip/CustomTooltip";
import moment from "moment";
import EntityDetailsModal from "../../modal-views/EntityDetailsModal";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";
import { StoreContext } from "../../contexts/StoreContext";

@inject("detailViewStore", "previewStore", "popupStore")
@observer
export class GenericListRepresentation extends React.Component {
  // subdomain -> subdomain enumeration -> member
  // variable set -> variable set enumeration -> variable
  // left side: member or variable standard clickable object - name(code) type maintenanceAgency
  // right side: validity range from parent enumeration
  constructor(props) {
    super(props);
    this.state = {
      showVariableDetailsModal: false,
      variableToshow: null,
    };
  }

  componentDidMount() {
    this.context.setSearchMatrix(this.props.searchMatrixKey, "");
  }
  handleToggleVariableDetailsModal = (e, detailsItem) => {
    e?.preventDefault();
    this.setState((oldState) => ({
      ...oldState,
      showVariableDetailsModal: !oldState.showVariableDetailsModal,
      variableToshow: { detailsItem, ...{ object: detailsItem } },
    }));
    return false;
  };

  getTitle(item) {
    const titleItems = [];

    if (!item) {
      return null;
    }

    if (item.name) {
      titleItems.push(
        <Link
          onClick={(e) => {
            this.handleToggleVariableDetailsModal(e, item);
          }}
          key="title-name"
          to={`/view/${item.type}/${item.tid}`}
          className="object-name"
        >
          {item.name}
        </Link>
      );
    }
    if (item.legalCode) {
      titleItems.push(
        <Link
          onClick={(e) => {
            this.handleToggleVariableDetailsModal(e, item);
          }}
          key="title-legalCode"
          to={`/view/${item.type}/${item.tid}`}
          className="object-name"
        >
          {item.legalCode}
        </Link>
      );
    }
    if (item.code) {
      titleItems.push(`(${item.code})`);
    }
    // titleItems.push(
    //   <Label key="title-type" className="object-type" bsStyle="success">
    //     {item.type}
    //   </Label>
    // );
    if (item.maintenanceAgencyId) {
      titleItems.push(
        <MaintenanceAgencyLabel
          maintenanceAgencyId={item.maintenanceAgencyId}
        ></MaintenanceAgencyLabel>
      );
    }

    return titleItems;
  }

  getValidity(obj) {
    return (
      <div className="validity-container">
        <p>
          <b>Valid From: </b>
          {moment(obj.validFrom).format("YYYY-MM-DD")}
          <b>Valid To: </b>
          {moment(obj.validTo).format("YYYY-MM-DD")}
        </p>
      </div>
    );
  }
  removeDuplicates = (list) => {
    const seen = new Set();
    return list.filter((item) => {
      const duplicate = seen.has(item.object.memberId);
      seen.add(item.object.memberId);
      return !duplicate;
    });
  };

  static contextType = StoreContext;
  render() {
    const { navigationLookupResult, object, searchMatrixKey } = this.props;
    const { variableToshow } = this.state;
    let items = [];
    const { fetchingDataStatus } = this.context;
    const isLoading =
      (object.type === "Subdomain" &&
        fetchingDataStatus.get("Members") === true) ||
      (object.type === "VariableSet" &&
        fetchingDataStatus.get("Variables") === true);
    if (
      !!navigationLookupResult &&
      !!navigationLookupResult.navigationLookupRootItem &&
      !!navigationLookupResult.navigationLookupRootItem.items &&
      !!navigationLookupResult.navigationLookupRootItem.object
    ) {
      items = navigationLookupResult.navigationLookupRootItem.items.filter(
        (item) => {
          // we support this view only for the following enumerated types: VariableSet, Subdomain
          if (object.type === "VariableSet") {
            return (
              item.items &&
              item.items[0] &&
              (item.items[0]?.object.type === "Variable" ||
                item.items[1]?.object.type === "Variable")
            );
          }
          if (object.type === "Subdomain")
            return (
              item.items &&
              item.items[0] &&
              item.items[0]?.object.type === "Member"
            );
          return false;
        }
      );

      if (!items && !isLoading) {
        return null;
      }
    }
    items = this.removeDuplicates(items);

    const searchExpr = this.context.getSearchMatrix[searchMatrixKey] || "";

    let filteredItems = items.filter((item) => {
      if (searchExpr) {
        const names = item.items.map((i) =>
          i.object.name ? i.object.name.toLowerCase() : ""
        );
        const codes = item.items.map((i) =>
          i.object.code ? i.object.code.toLowerCase() : ""
        );
        return (
          names.some((name) => name.includes(searchExpr.toLowerCase())) ||
          codes.some((code) => code.includes(searchExpr.toLowerCase()))
        );
      } else {
        return true;
      }
    });

    const filteredItemsLength = filteredItems.filter(
      (item) => item.items.length > 0
    ).length;

    return (
      <div className="custom-panel">
        <div className="custom-panel-heading">
          <div style={{ display: "flex" }}>
            <h4>
              {object.type === "Subdomain"
                ? "Members (allowed values)"
                : object.type === "VariableSet"
                ? "Variables (allowed values)"
                : "Related"}
              {items
                ? " (" + filteredItemsLength + "/" + items.length + ")"
                : " (0/0)"}
            </h4>
            {isLoading ? (
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : (
              ""
            )}
          </div>
          <CustomTooltip
            type={
              object.type === "Subdomain"
                ? "member"
                : object.type === "VariableSet"
                ? "variable"
                : ""
            }
          />
        </div>
        <div className="custom-panel-body">
          <ListSearch
            searchMatrixKey={searchMatrixKey}
            placeholder={"Filter by Name or Code"}
          />
          <div className="item-list-container">
            <Grid fluid={true} style={{ paddingLeft: 0 }}>
              {filteredItems
                .filter((item) => item.items && item.items[0])
                .sort((a, b) =>
                  a.items[0].object.code.localeCompare(b.items[0].object.code)
                )
                .map((item, key) => (
                  <Row key={key}>
                    <Col xs={8}>
                      <div className="related-types-list">
                        {this.getTitle(item.items[0].object)}
                      </div>
                    </Col>
                    <Col xs={4}>{this.getValidity(item.object)}</Col>
                  </Row>
                ))}
            </Grid>
          </div>
        </div>
        {this.state.showVariableDetailsModal && (
          <StoreContext.Provider value={this.props.popupStore}>
            <EntityDetailsModal
              variable={null}
              cubeVariableName={"[No name]"}
              cubeVariableCode={null}
              details={variableToshow ? variableToshow : filteredItems[0]}
              // onClose={this.handleToggleVariableDetailsModal}
              onClose={(e) => {
                this.handleToggleVariableDetailsModal(e, variableToshow);
              }}
            />
          </StoreContext.Provider>
        )}
      </div>
    );
  }
}
